import React from 'react';

interface SliderPaginationProps {
  totalSlides: number;
  currentIndex: number;
  onClick: (index: number) => void;
}

const LiteSliderPagination: React.FC<SliderPaginationProps> = ({
  totalSlides,
  currentIndex,
  onClick,
}) => {
  return (
    <div className="liteSlider__pagination" role="navigation">
      {Array.from({ length: totalSlides }).map((_, index) => (
        <button
          key={index}
          type="button"
          className={`liteSlider__pagination-link ${currentIndex === index ? 'active' : ''}`}
          onClick={() => onClick(index)}
        >
          <span className={'liteSlider__pagination-holder'}></span>
          <span className="blind">Go to slide {index + 1}</span>
        </button>
      ))}
    </div>
  );
};

export default LiteSliderPagination;
